import { useEffect, useState } from "react";
import { Platform } from "react-native";

export const COARSE_POINTER = "(hover: none), (pointer: coarse)";

export type AskTheDevice = ((query: string) => { matches: boolean }) | null | undefined;

export function coarsePointer(ask: AskTheDevice): boolean {
  if (!ask) return true;
  try {
    return ask(COARSE_POINTER).matches;
  } catch {
    return true;
  }
}

function askThisDevice(): AskTheDevice {
  if (Platform.OS !== "web" || typeof window === "undefined") return null;
  return window.matchMedia ? (query: string) => window.matchMedia(query) : null;
}

export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(() => coarsePointer(askThisDevice()));
  useEffect(() => {
    if (!askThisDevice()) return;
    const query = window.matchMedia(COARSE_POINTER);
    const listen = () => setCoarse(query.matches);
    query.addEventListener("change", listen);
    return () => query.removeEventListener("change", listen);
  }, []);
  return coarse;
}
